module.exports = __webpack_public_path__ + "static/media/product-slack.5a750585.svg";